/**
 * @title rxtransferprescription.js: Sub-module for Rx Transfer Prescription pages
 * @description This module is used to handle various tasks related to transfer prescriptions
 * @dependency rxaddresshelper
 */
define(['rxaddresshelper'], function(rxAddressHelper) {	
	
	var rxTransferPrescription = {
		
		/**
		 * Initializes Transfer Prescription module.
		 */
		init : function(options) {
			if (options != undefined) {
				rxAddressHelper.init(options);				
			}
			rxTransferPrescription.populateStateSelectBox();
			rxTransferPrescription.bindEvents();
			rxTransferPrescription.addCustomValidators();
			rxTransferPrescription.maskInput();
			console.log('Transfer Prescription module initialized.');
		},
		/**
		 * Populates state select field
		 */
		populateStateSelectBox: function() {
			let form = rxTransferPrescription.getForm();
		    if (form.find('.state-select').length) {
		    	let stateProvList = this.getStateProvJson();
		        let stateOptions = this.getStateOptions(stateProvList);
		        form.find('.state-select').append(stateOptions);
		    }
		    let state_default =  $('input[name=pharmacyState]').val();
		    if(state_default != "") {
		    	form.find('.state-select').val(state_default);
		    }
		    else {
		    	form.find('.state-select').val("NO_STATE_TYPE_SELECTED");
		    }
		    
		},
		getForm: function() {
			return $('#transfer-prescription-form');
		},
		/**
	      * [description]
	      * @param  {[type]} stateProvList [description]
	      * @return {[type]}               [description]
	      */
	     getStateOptions: function(stateProvList) {
			return COSTCO.CAddressForm.getStateOptions(stateProvList);
	     },
	     /**
	      * [description]
	      * @return {[type]} [description]
	      */
	     getStateProvJson: function() {
	    	 //return COSTCO.CAddress.getStateProvJson();
	    	 return transferPrescriptionCountry;
	     },
		/**
		 * Binds events on page.
		 */
		bindEvents: function() {
			// Prevent submit form when pressing Enter in Warehouse Location input field, and execute findWarehouse(keyword)
			$('#warehouse-search-keyword').keypress(function(event) {
				if (event.keyCode == 13) {
					event.preventDefault();
					rxTransferPrescription.findWarehouse($('#warehouse-search-keyword').val());
				}
			});

			$('#find-warehouse-onclick-submit').click(function() {
				rxTransferPrescription.findWarehouse($('#warehouse-search-keyword').val());
			});
			
			$('#add-more-prescriptions-button').click(function() { 
				COSTCO.rxPrescriptionHelper.drugSection.addMorePrescriptions('drug-info-block', 'transfer_single_drug_row');
			});
			
			$('#transfer-prescription-next-button').click(function(event) {
				rxTransferPrescription.validateAndSubmit(event);
			});
			
			$('#default-shipping-tooltip').popover({
		          trigger: 'hover focus',
		          placement: 'top',
		    });
			
			$('#default-shipping-tooltip').on('keydown', function(event) {
		          if (event.which == 27)
		            $(this).popover('hide');
		    });
			
			$('#prescription-information-tooltip').popover({
				trigger: 'hover focus',
				placement: 'top',
			});
			
			$('#prescription-information-tooltip').on('keydown', function(event) {
		          if (event.which == 27)
		            $(this).popover('hide');
		    });
			
			$('#ship-when-ready').click(function() {
				$('#billing-and-shiping').show();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', true);
				}
			});
			
			$('#notify-when-ready').click(function() {
				$('#billing-and-shiping').hide();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', false);
				}
			});
		},
		
		/**
		 * Form ID.
		 */
		FORM_ID: 'transfer-prescription-form',
		
		/**
		 * Initial value.
		 */
		validationRulesApplied: false,
		
		/**
		 * Validation rules for Transfer prescription
		 */ 
		validationRules: function() {

			if (!rxTransferPrescription.validationRulesApplied) {
				$.validator.addMethod("notEqual", function(value, element, param) {
					return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
				$.validator.addMethod("pharmacyPhone", function( value, element ) {
					return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
				}, messages.ERR_INVALID_PHONE1);				
				$.validator.addMethod("prescriptionNumber_invalid", function( value, element ) {
					return this.optional(element) || /(^[0-9a-zA-Z\s\-]+$)/.test(value);
				}, messages.ERR_INVALID_RX_NUMBER);				
				$.validator.addMethod("drugName_0", function( value, element ) {
					 return !this.optional(element) && /(^[0-9a-zA-Z\s\-\%\*\,\.\/\&\(\)]+$)/.test(value);
				}, messages.ERR_INVALID_PRESCRIPTION_DRUG_NAME);
				$.validator.addMethod("drugName_others", function( value, element ) {
					 return this.optional(element) || /(^[0-9a-zA-Z\s\-\%\*\,\.\/\&\(\)]+$)/.test(value);
				}, messages.ERR_INVALID_PRESCRIPTION_DRUG_NAME);
				$.validator.addMethod("drugName_w_rxNum", function( value, element ) {
					 var id=element.id.split("_"); 
					 var prescriptionNumberId = "#prescriptionNumber_" + id[1];
					 var prescriptionNumberValue = $(prescriptionNumberId).val();
					 return prescriptionNumberValue !== "" && this.optional(element)? false: true;
				}, messages.ERR_REQUIRED_DRUG_NAME);
				$.validator.addMethod("pharmacyName", function( value, element ) {
					return COSTCO.util.ATLEAST_ONE_ALPHABET.test(value);
				}, messages.ERR_REQUIRED_PHARMACY_NAME);
				
				rxTransferPrescription.validationRulesApplied = true;
			}
	    },
	    
	    /**
	     * Add custom rules to the form validation
	     */
		addCustomValidators : function(){
			
	    	//Ensures given element is not visible on the page in order to continue
			$.validator.addMethod("isNotVisible", function(value, element, param) {
				return !$(element).is(":visible");
			}, messages.ERR2_REQUIRED_WAREHOUSE_NUMBER);
			
		},
		maskInput: function() {
	    	 $('#transfer-prescription-form').find('[name=pharmacyPhone]').unmask().mask('(000) 000-0000');
	     },
		/**
	     * Form validation.
	     */
	    validate: function() {
	    	$("#red-box-error").addClass("hidden");
	    	rxTransferPrescription.validationRules();
	    	let form = $('#' + rxTransferPrescription.FORM_ID);
			if (form.length > 0) {
				form.validate({
					focusInvalid: false,
					ignore: '',
					invalidHandler: COSTCO.util.invalid_handler,

					rules : {
						warehouseSearchKeyword : {isNotVisible:true},
						drugName_0: {required : true, drugName_0:true},
						pharmacyName: {required : true, pharmacyName:true},
						pharmacyPhone: {required : true},
						pharmacyCity: {required : true},
						pharmacyState: {required: true, notEqual:"NO_STATE_TYPE_SELECTED"}
					},
					messages : {
						warehouseSearchKeyword: {
							digits: messages.ERR_INVALID_WAREHOUSE_NUMBER
						},
						drugName_0:	{required : messages.ERR_REQUIRED_DRUG_NAME},
						pharmacyName: {required : messages.ERR_REQUIRED_PHARMACY_NAME},
						pharmacyPhone: {required : messages.ERR_INVALID_PHONE1},
						pharmacyCity: {required : messages.ERR_REQUIRED_PHYSICIAN_CITY},
						pharmacyState: {required : messages.ERR_INVALID_STATE}
					},
					errorPlacement: function(error, element) {
						if (element.hasClass('drug-name') || element.hasClass('prescription-number')) {					
							error.insertAfter(element);
						}
						else if(element.attr('id') == 'warehouse-search-keyword'){
							error.insertAfter(element.closest('.input-group'));
						}
						
						if (element.hasClass('input-outline')) {					
							error.insertAfter(element);
						}
					}
				})				
				$.validator.addClassRules("prescription-number", {
		            prescriptionNumber_invalid: true   
				});
				$.validator.addClassRules("drug-name", {
					drugName_others: true, drugName_w_rxNum: true   
				});
			}
			return form.valid();
		},

		/**
		 * Redirects to Warehouse Location page, passing the search keyword as parameter.
		 * @param {string} searchKeyword Search term.
		 */
		findWarehouse: function(searchKeyword) {
			if (searchKeyword == null || searchKeyword == undefined) {
				searchKeyword = '';
			}
			let prescriptionForm = document.forms[rxTransferPrescription.FORM_ID];
			prescriptionForm.location.value = searchKeyword.trim();
			prescriptionForm.action = '/transfer-warehouse-location?storeId=' + wcs.storeId 
				+ '&langId=' + wcs.langId 
				+ '&catalogId=' + wcs.catalogId 
				+ '&isPharmacy=true&location=' + searchKeyword.trim();
			COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
			prescriptionForm.submit();
		},
		
		/**
		 * Validates data and submits the form.
		 */
		validateAndSubmit: function(event) {
			if (rxTransferPrescription.validate()) {
				COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
				$('#' + rxTransferPrescription.FORM_ID).submit();
			}else{
				event.preventDefault();
			}
		}
	}

	if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxTransferPrescription = rxTransferPrescription;
		
	return rxTransferPrescription;
});


// WEBPACK FOOTER //
// ./js/rx/rxtransferprescription.js